export const updateCompanies = (value) => ({
    type: "UPDATE_COMPANIES",
    payload: value,
});
